module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// /home/deploy/gamba/shared/rnclient/node_modules/symbol-observable/index.js
// module id = 1215
// module chunks = 4